var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSmiley = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M40.7 22c0 10.328-8.372 18.7-18.7 18.7S3.3 32.328 3.3 22 11.672 3.3 22 3.3 40.7 11.672 40.7 22m3.3 0c0 12.15-9.85 22-22 22S0 34.15 0 22 9.85 0 22 0s22 9.85 22 22m-30.25-9.9v6.6h3.3v-6.6zm13.201 6.6v-6.6h3.3v6.6zm-4.95 14.85a9.35 9.35 0 0 1-9.35-9.35h-3.3c0 6.986 5.663 12.65 12.65 12.65 6.986 0 12.65-5.664 12.65-12.65h-3.3A9.35 9.35 0 0 1 22 33.55",
    clipRule: "evenodd"
  })));
};
export default SvgIconSmiley;